import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const LeftSection = styled.div`
  display: flex;
  flex: 1;
`;

const CenterSection = styled.div`
  display: flex;
  justify-content: center;
  flex: 1;
`;

const RightSection = styled.div`
  display: flex;
  flex: 1;
  justify-content: flex-end;
`;

export { Container, RightSection, LeftSection, CenterSection };
